import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  CompanySpacesUserLabelsIdDeleteRequest,
  CompanySpacesUserLabelsIdPutRequest,
  CompanySpacesUserLabelsPostRequest,
  UserLabel,
  UserLabelApi,
} from '../generated-api';
import { API_CONFIG } from '../app/api-config';

const userLabelApi = new UserLabelApi(API_CONFIG);

export const fetchUserLabels = createAsyncThunk('userLabels/all', async () => {
  return await userLabelApi.companySpacesUserLabelsGet({ includeCounts: true });
});

export const createUserLabel = createAsyncThunk(
  'userLabels/create',
  async (request: CompanySpacesUserLabelsPostRequest) => {
    return await userLabelApi.companySpacesUserLabelsPost(request);
  }
);

export const updateUserLabel = createAsyncThunk(
  'userLabels/update',
  async (request: CompanySpacesUserLabelsIdPutRequest) => {
    return await userLabelApi.companySpacesUserLabelsIdPut(request);
  }
);

export const deleteUserLabel = createAsyncThunk(
  'userLabels/delete',
  async (request: CompanySpacesUserLabelsIdDeleteRequest) => {
    return await userLabelApi.companySpacesUserLabelsIdDelete(request);
  }
);

const initialState = {
  items: [] as UserLabel[],
};

export type UserLabelsState = typeof initialState;

export const userLabelsSlice = createSlice({
  name: 'userLabels',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserLabels.fulfilled, (state, action) => {
      return { ...state, items: action.payload.user_labels };
    });
  },
});

export const userLabelsReducer = userLabelsSlice.reducer;
